/**
 * Shared list-page header: title, human-readable subtitle, optional meta (counts), optional actions.
 */
export function AdminPageHeader({ title, subtitle, meta, actions }) {
    return (
        <header className="uc-admin-page-header flex flex-wrap justify-content-between align-items-start gap-3">
            <div className="min-w-0 flex-1">
                <div className="flex align-items-center gap-2 flex-wrap">
                    <span className="uc-admin-page-header-accent" aria-hidden />
                    <h1 className="uc-admin-page-title font-bold text-900 m-0">{title}</h1>
                </div>
                {subtitle ? (
                    <p className="uc-admin-page-subtitle text-600 mt-2 mb-0">{subtitle}</p>
                ) : null}
                {meta ? (
                    <p className="uc-admin-page-meta text-500 text-sm mt-2 mb-0">
                        <i className="pi pi-chart-bar text-primary mr-2" aria-hidden />
                        {meta}
                    </p>
                ) : null}
            </div>
            {actions ? (
                <div className="uc-admin-page-actions flex flex-wrap align-items-center gap-2 flex-shrink-0 surface-card border-1 surface-border border-round-lg p-2 shadow-1">
                    {actions}
                </div>
            ) : null}
        </header>
    );
}
